export enum OrderStatus {
  noOrder = 'NO_ORDER', // used by OrderStatusIcon
  completed = 'COMPLETED',
  pending = 'PENDING',
  sending = 'SENDING', // used by OrderProgressBar
  failed = 'FAILED',
} // combination of TransactionStatus and UI

export enum TransactionStatus {
  completed = 'COMPLETED',
  pending = 'PENDING',
  error = 'ERROR', // check event could return error as the status
}

export enum LoyaltyResponseStatus {
  sending = 'ELOYALTYMEMBERSENDING',
  pending = 'ELOYALTYMEMBERCHECKING',
  valid = 'ELOYALTYMEMBERFOUND',
  invalid = 'ELOYALTYMEMBERNOTFOUND',
}

// SLA (Service Level Agreement): maximum acceptable time (ms) for an order to be fully processed from the moment it is sent until the check response is received
export const SLA_THRESHOLD_MS = 5000;

// POSLINK order_status error codes after which a resend can never succeed —
// unlike 7002 ("Send Order is Pending", retryable once the in-flight
// transaction clears), 7008 means the POS already holds the FINAL order for
// this car and will reject every further order event in the session.
export const TERMINAL_ORDER_STATUS_CODES = [7008];

// POSLINK 7002 "Send Order is Pending": the request collided with a
// transaction still in flight and was dropped (no check event ever follows
// it). POSLINK queues *final* orders behind the pending transaction, and every
// order event carries the full cart, so the dropped interim request is
// recoverable by any later send (HITL-1417).
export const ORDER_PENDING_ERROR_CODE = 7002;
